"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeFiles_en_us = void 0;
function backofficeFiles_en_us() {
    return {
        "backoffice.files.title": "Files",
        "backoffice.files.projectspecific": "Files specific to project",
        "backoffice.files.global": "Cross-project files of the company",
        "backoffice.files.filename": "Name",
        "backoffice.files.filesize": "Size",
        "backoffice.files.filetype": "Type",
        "backoffice.files.createdat": "Created",
        "backoffice.files.lastmodified": "Last modified",
        "backoffice.files.openoriginal": "Download file",
        "backoffice.files.copydownloadurl": "Copy download link",
        "backoffice.files.deletefile": "Delete file",
        "backoffice.files.listempty": "Nothing to display! You did not upload any files yet...",
        "backoffice.files.emptytitle": "No files found...",
        "backoffice.files.emptymessage": "No files were uploaded yet",
        "backoffice.files.showqr": "Download link as QR Code",
        "backoffice.files.license": "License",
        "backoffice.files.licenseurl": "License-URL",
        "backoffice.files.onlinesearch": "ONLINE SEARCH",
        "backoffice.files.onlineimgsearch": "Online Image Search",
        "backoffice.files.entersearchterm": "Enter a search term...",
        "backoffice.files.nosearchresults": "No search results",
        "backoffice.files.saveimg": "Save image:",
        "backoffice.files.imgsize.full": "Full",
        "backoffice.files.imgsize.regular": "Regular",
        "backoffice.files.imgsize.small": "Small"
    };
}
exports.backofficeFiles_en_us = backofficeFiles_en_us;
